import React, { memo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CommonTypography from '@src/new-components/Typography';
import actions from '@src/redux/actions';
import { DUBBING_PANEL_VIEW } from '@src/constants/dubbing';
import { StyledCaptionPanel } from './index.style';
import StyleList from './StyleList';
import StyleConfig from './StyleConfig';

// Replaces the block list while subtitles are open.
const CaptionPanel = ({ isLocked }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const view = useSelector((state) => state.layout.dubbingPanelView);
  const isConfig = view === DUBBING_PANEL_VIEW.CAPTION_CONFIG;

  const goTo = (nextView) =>
    dispatch(actions.layout.setDubbingPanelView(nextView));

  return (
    <StyledCaptionPanel>
      <div className="caption-panel-header">
        {isConfig && (
          <button
            type="button"
            className="caption-panel-icon-button"
            aria-label={t('goBack')}
            onClick={() => goTo(DUBBING_PANEL_VIEW.CAPTION_STYLES)}
          >
            <ArrowBackRoundedIcon />
          </button>
        )}

        <CommonTypography
          className="caption-panel-title"
          variant="body-20-semibold"
        >
          {t(isConfig ? 'captionSettings' : 'projectCaption')}
        </CommonTypography>

        {!isConfig && (
          <button
            type="button"
            className="caption-panel-icon-button"
            aria-label={t('close')}
            onClick={() => goTo(DUBBING_PANEL_VIEW.BLOCK_LIST)}
          >
            <CloseRoundedIcon />
          </button>
        )}
      </div>

      <div
        className={classNames('caption-panel-body', {
          'caption-panel-body-locked': isLocked,
        })}
      >
        {isConfig ? <StyleConfig /> : <StyleList />}
      </div>
    </StyledCaptionPanel>
  );
};

export default memo(CaptionPanel);
